export const overviewItems = [
  {
    id: "courses",
    href: "#courses",
    label: "Cursos de trabajo seguro en alturas",
  },
  {
    id: "services",
    href: "#services",
    label: "Servicios de seguridad industrial",
  },
  {
    id: "products",
    href: "#products",
    label: "Equipos y elementos de protección",
  },
  {
    id: "about",
    href: "#about",
    label: "Quiénes somos y nuestra trayectoria",
  },
  {
    id: "team",
    href: "#team",
    label: "Personal e instructores certificados",
  },
  {
    id: "quality",
    href: "#quality",
    label: "Política de calidad y NTC 6072",
  },
  {
    id: "practices",
    href: "#practices",
    label: "Prácticas e instalaciones propias",
  },
  {
    id: "clients",
    href: "#clients",
    label: "Empresas que confían en nosotros",
  },
];
